import type { CanonicalLoad } from '@numeo/types-core'
import { escapeHtml } from '@/utils/escape-html'
import { applyTemplateVariables, type UserCompanyData } from 'features/load-hub/utils/emailTemplateUtils'
import { DRIVER_TEMPLATE_VARIABLE_KEYS } from '@/features/load-hub/components/expanded-row/savedTemplate'
import { EMAIL_TEMPLATE_VARIABLES } from '../constants/emailTemplateVariables'

export const buildTemplatePreviewValues = (
    load: CanonicalLoad,
    companyData: UserCompanyData,
    extraVariables?: Record<string, string | null | undefined>
): Record<string, string> => {
    const values: Record<string, string> = {}
    for (const variable of EMAIL_TEMPLATE_VARIABLES) {
        values[variable.key] = applyTemplateVariables(`{{${variable.key}}}`, load, companyData)
    }
    for (const key of DRIVER_TEMPLATE_VARIABLE_KEYS) values[key] = extraVariables?.[key] || '-'
    return values
}

export const renderTemplatePreview = (template: string, values: Readonly<Record<string, string>>, html: boolean): string => {
    return Object.entries(values).reduce((rendered, [key, value]) => {
        const replacement = html && key !== 'company_logo' ? escapeHtml(value) : value
        return rendered.replace(new RegExp(`\\{\\{\\s*${key}\\s*\\}\\}`, 'g'), () => replacement)
    }, template)
}

export const buildVariableDisplayValues = (values: Readonly<Record<string, string>>): Record<string, string> => ({
    ...values,
    company_logo: values.company_logo ? 'Uploaded company logo' : 'No company logo',
})
